;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.AccountBuilder = Model.AccountBuilder.extend({
		setCustomInit: function(){

			this.set(
				{
					form_templates: 'Clubs_',
					game : 'JMC Tipping',
					your_details_fields: 'avatar,team_name,team_supported,first_name,last_name,email,country,state,postcode,mobile,birthday',
					socialConnect: {
						facebook: true,
						twitter: false
					},
					regions: [
						{ id: 'account', name: 'Your details', url: 'account'},
						{ id: 'changePassword', name: 'Change Password', url: 'account/change_password'},
						{ id: 'notifications', name: 'Communications', url: 'account/notifications'},
						{ id: 'socialConnections', name: 'Social Connections', url: 'account/social_connections'},
						{ id: 'contactUs', name: 'Contact us', url: 'help/contact-us'}
					],
					menuItems: [
						{ name: 'Your details', url: 'account', status: ''},
						{ name: 'Change Password', url: 'account/change_password', status: ''},
						{ name: 'Communications', url: 'account/notifications', status: ''},
						{ name: 'Social Connections', url: 'account/social_connections', status: ''},
						{ name: 'Contact us', url: 'help/contact-us', status: ''}
					],
				}
			);

			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));